export const CheckVerifyBG = () => {
    return (
        <svg width="83" height="82" viewBox="0 0 83 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.19434" y="1.5" width="78.6062" height="78.6062" rx="39.3031" fill="#E50AAC" stroke="white" strokeWidth="3" />
            <g clipPath="url(#clip0_1383_2127)">
                <path d="M15.9998 29.3327C8.63584 29.3327 2.6665 23.3633 2.6665 15.9993C2.6665 8.63535 8.63584 2.66602 15.9998 2.66602C23.3638 2.66602 29.3332 8.63535 29.3332 15.9993C29.3332 23.3633 23.3638 29.3327 15.9998 29.3327ZM14.6705 21.3327L24.0972 11.9047L22.2118 10.0193L14.6705 17.562L10.8985 13.79L9.01317 15.6753L14.6705 21.3327Z" fill="white" transform="translate(25, 25)" />
            </g>
            <defs>
                <clipPath id="clip0_1383_2127">
                    <rect width="70" height="70" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}